import type { EvidenceTrack } from '@wtta/scoring'

interface EvidenceSectionProps {
  tracks: EvidenceTrack[]
}

export function EvidenceSection({ tracks }: EvidenceSectionProps) {
  if (tracks.length === 0) return null

  return (
    <section className="report-section evidence" data-testid="evidence-section">
      <h2 className="report-section__title">Wat je moet kunnen tonen</h2>
      <p className="report-section__lead">
        Wtta-toezicht draait om bewijs. Hieronder de minimale dossierset,
        opgesplitst naar wat je nodig hebt om de toelating te verkrijgen en wat
        je doorlopend op orde moet hebben om hem te behouden.
      </p>

      {tracks.map((track) => (
        <article
          key={track.kind}
          className={`evidence__track evidence__track--${track.kind}`}
          data-testid={`evidence-track-${track.kind}`}
        >
          <h3 className="evidence__track-title">{track.title}</h3>
          <p className="evidence__track-lead">{track.lead}</p>
          <ul className="evidence__items">
            {track.items.map((item) => (
              <li
                key={item.id}
                className="evidence__item"
                data-testid={`evidence-${item.id}`}
              >
                <h4 className="evidence__item-title">{item.title}</h4>
                <p className="evidence__item-description">{item.description}</p>
                <p className="evidence__item-note">{item.practicalNote}</p>
              </li>
            ))}
          </ul>
        </article>
      ))}
    </section>
  )
}
